import {makeStyles, createStyles, Theme} from "@material-ui/core/styles"
import { GREY_COLOR, WHITE_COLOR } from "~/constants/colors"

export default makeStyles((theme: Theme) => createStyles({
    mainContainer: {
        width: 'calc(100% - 160px)',
        margin: '0 80px 24px',
        backgroundColor: GREY_COLOR.Grey6,
        borderRadius: 4,
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.08)',
        [theme.breakpoints.down('md')]: {
            width: '100%',
            margin: '0 0 24px'
        }

    },
    titleBlock: (open: boolean) => ({
        height: 80,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '26px 32px',
        boxSizing: 'border-box',
        borderRadius: open ? '4px 4px 0 0' :4,
        backgroundColor: open ? GREY_COLOR.Grey2 : GREY_COLOR.Grey6,
        [theme.breakpoints.down('xs')]: {
            padding: '26px 24px'
        }
    }),
    title: (open) => ({
        color: open ? WHITE_COLOR : GREY_COLOR.Grey1
    }),
    icon: {},
    contentBlock: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: '40px 32px',
        [theme.breakpoints.down('md')]: {
            padding: '24px 24px 64px'
        },
        [theme.breakpoints.down('md')]: {
            padding: '40px 88px 64px 24px'
        },
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start'
        },
        [theme.breakpoints.down('xs')]: {
            padding: '40px 16px 64px'
        }
    },
    contentItem: {
        marginBottom: 24
    },
    contentImage: {
        width: 'calc(50% - 32px)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        borderRadius: 4,
        height: 352,
        marginLeft: 32,
        [theme.breakpoints.down('md')]: {
            height: 288
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
            width: '100%',
            height: 384
        },
        [theme.breakpoints.down('xs')]: {
            height: 208
        }
    },
    contentInfo: {
        width: '50%',
        [theme.breakpoints.down('sm')]: {
            marginBottom: 8,
            width: '100%'
        }
    },
    itemTitle: {
        marginBottom: 16
    },
    itemText: {}
}));
